import React from "react";
import { Redirect } from "react-router-dom";

function isAdminSession() {
  const raw = sessionStorage.getItem("admin");
  return raw === "true" || raw === "1";
}

/** 플랫폼 admin 플래그가 없으면 /admin 진입 차단 */
function withRequireAdmin(WrappedComponent, redirectTo = "/") {
  function RequireAdminGuard(props) {
    if (!window.$Global.hasLoginToken()) {
      return <Redirect to="/login" />;
    }
    if (!isAdminSession()) {
      alert("권한이 없습니다");
      return <Redirect to={redirectTo} />;
    }
    return <WrappedComponent {...props} />;
  }

  const name =
    WrappedComponent.displayName || WrappedComponent.name || "Component";
  RequireAdminGuard.displayName = `withRequireAdmin(${name})`;
  return RequireAdminGuard;
}

export default withRequireAdmin;
